
<div ref="roomsContainer" class="rooms">
  <div v-if="getRoomsDatas === null">Aucune salle existante</div>
  <div class="rooms-editing">
    <div>
      <el-slider v-if="zoomSliderIsVisible" v-model="scaleStage" @change="setSliderScale" vertical
        height="100px"></el-slider>
    </div>
  </div>
  <div class="black-inputs rooms-editing-center" v-if="!viewIsCentered">
    <el-button @click="centerRoom" class="dark" type="primary">Recentrer</el-button>
  </div>
  <v-stage ref="stage" :config="configKonva" v-if="getRoomsDatas !== null" @contentClick="handleStageClick">
    <v-layer>
      <v-rect ref="bckg" :config="configBackground" @click="unselect" @tap="unselect" @dragend="dragEndRoom"></v-rect>
    </v-layer>
    <v-layer ref="mainLayer" :config="configMainLayer">
      <v-group ref="zoneEditable">
        <v-rect :config="configZoneEditable"></v-rect>
        <v-image v-if="getStyleEdition" :config='configGridPoint'></v-image>
      </v-group>
      <v-group ref="linkedGroup">
        <Link v-for="link in getLinkedTables" :key="link.id" :tables="link" />
      </v-group>
      <v-group ref="baseGroup">
        <Table v-for="table in tables" :key="table.id" :table="table" :stage="$refs['stage']"
          :limits="$refs['zoneEditable']" :mainLayer="$refs['mainLayer']"></Table>
      </v-group>
      <v-group ref="dragGroup" :config="configDragLayer" v-if="getRoomsDatas !== null">
        <Table v-for="table in tablesDragging" :key="table.id" :table="table" :stage="$refs['stage']"
          :limits="$refs['zoneEditable']" :mainLayer="$refs['mainLayer']"></Table>
      </v-group>
    </v-layer>
  </v-stage>
  <div v-if="getRoomIsLock && !getModEdition" class="rooms-lock"></div>
</div>
